<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex :class="procurementPlan.id ? 'sm6' : 'sm12'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="procurementPlan.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="procurementPlan.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="procurementPlan.warehouseId"
                  :items="activeWarehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :readonly="
                    status == 'CONFIRM' ||
                      status == 'CANCEL' ||
                      status == 'PENDING' ||
                      (user.role.roleName == 'PROCUREMENT_MANAGER' &&
                        user.warehouseId)
                  "
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="procurementPlan.type"
                  :items="typeList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Purchase Type..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="
                    status == 'CONFIRM' ||
                      status == 'CANCEL' ||
                      status == 'PENDING'
                  "
                  :rules="rules.typeRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="procurementPlan.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="Plan Year"
                  label="Plan Year"
                  v-model="procurementPlan.planYear"
                  type="text"
                  :rules="rules.descriptionRules"
                  :readonly="
                    status == 'CONFIRM' ||
                      status == 'CANCEL' ||
                      status == 'PENDING'
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="procurementPlan.description"
                  type="text"
                  :rules="rules.descriptionRules"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="procurementPlan.remark"
                  type="text"
                  :rules="rules.remarkRules"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="procurementPlan.id">
                <v-text-field
                  label="Created Date"
                  v-model="createdDate"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="procurementPlan.id">
                <v-text-field
                  label="Created By"
                  v-model="procurementPlan.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="procurementPlan.id">
                <v-text-field
                  label="Updated Date"
                  v-model="updatedDate"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="procurementPlan.id">
                <v-text-field
                  label="Updated By"
                  v-model="procurementPlan.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <!--<v-flex xs12 ml-2 mt-1>
                <v-switch
                  v-model="isItemDiscount"
                  inset
                  :label="'discount'"
                  @change="toggleDiscount"
                  :disabled="
                    status == 'ဝယ်ယူပြီးစီးမှု'
                  "
                ></v-switch>
              </v-flex>-->
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="showProducts()"
                    :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                  >
                    Add Purchase Plan Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex xs5 ml-4 mr-3 mt-2>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      :loading="barcodeLoading"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      prepend-icon="filter_center_focus"
                      :disabled="
                        status == 'CONFIRM' ||
                          status == 'CANCEL' ||
                          status == 'PENDING' ||
                          user.role.roleName == 'FINANCE_MANAGER'
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <!-- detail table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailCodeSearch"
                        placeholder="Enter product code"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailNameSearch"
                        append-icon="search"
                        placeholder="Enter product name"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="detailHeaders"
                    :items="detailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.productCode }}</td>
                      <td>{{ props.item.productName }}</td>
                      <td>{{ props.item.currencyCode }}</td>
                      <td>{{ props.item.factorUnitName }}</td>
                      <td>{{ props.item.planQty | decFormat(6) }}</td>
                      <td>{{ props.item.poQty | decFormat(6) }}</td>
                      <td>
                        {{ Number(props.item.unitCost) | decFormat(6) }}
                      </td>
                      <td>
                        {{ Number(props.item.totalCost) | decFormat(6) }}
                      </td>
                      <td>{{ props.item.description }}</td>
                      <td>{{ props.item.remark }}</td>
                      <!-- actions -->
                      <td>
                        <v-layout>
                          <v-btn
                            flat
                            icon
                            color="blue lighten-2"
                            @click="editDetail(props.item)"
                            :disabled="
                              status == 'CONFIRM' || status == 'CANCEL'
                            "
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            @click="removePurchasePlanItem(props.item.id)"
                            :disabled="
                              status == 'CONFIRM' ||
                                status == 'CANCEL' ||
                                (status == 'PENDING' && props.item.id >= 0)
                            "
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <!-- <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="showAssets()"
                    :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                  >
                    ADD PROCUREMENT PLAN ASSET
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>

                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="assetNameSearch"
                        append-icon="search"
                        placeholder="Enter Asset name"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="assetHeaders"
                    :items="assetDetailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.assetName }}</td>
                      <td>{{ props.item.currencyCode }}</td>
                      <td>{{ props.item.unitName }}</td>
                      <td>{{ props.item.planQty | decFormat(6) }}</td>
                      <td>
                        {{ Number(props.item.unitCost) | decFormat(6) }}
                      </td>
                      <td>
                        {{ Number(props.item.totalCost) | decFormat(6) }}
                      </td>
                      <td>{{ props.item.description }}</td>
                      <td>{{ props.item.remark }}</td>
                      
                      <td>
                        <v-layout>
                          <v-btn
                            flat
                            icon
                            color="blue lighten-2"
                            @click="editAsset(props.item)"
                            :disabled="
                              status == 'CONFIRM' || status == 'CANCEL'
                            "
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            @click="removePurchasePlanAsset(props.item.id)"
                            :disabled="
                              status == 'CONFIRM' ||
                              status == 'CANCEL' ||
                              (status == 'PENDING' && props.item.id >= 0)
                            "
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex> -->
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="
                      btnDisabled || status == 'CONFIRM' || status == 'CANCEL'
                    "
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    @click="onSave"
                    :disabled="
                      btnDisabled ||
                        saveLoading ||
                        status == 'CONFIRM' ||
                        status == 'CANCEL'
                    "
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog
      v-model="purchasePlanItemDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title class="blue darken-3">
          <span class="title white--text">Purchase Plan Item</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="detailForm" v-model="detailValid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="productCode"
                  label="Product Code"
                  v-model="selectedPurchasePlanItem.productCode"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="productName"
                  label="Product Name"
                  v-model="selectedPurchasePlanItem.productName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-model="selectedPurchasePlanItem.factorUnitName"
                  :hide-no-data="true"
                  :items="selectedPurchasePlanItem.productUnits"
                  color="blue-grey lighten-2"
                  label="Unit"
                  item-value="factorUnitName"
                  item-text="factorUnitName"
                  menu-props="auto"
                  @change="(option) => initPrice(option)"
                  :readonly="
                    status == 'CONFIRM' ||
                      status == 'CANCEL' ||
                      (status == 'PENDING' && selectedPurchasePlanItem.id >= 0)
                  "
                  :rules="rules.unitRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-model="selectedPurchasePlanItem.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                  :readonly="
                    status == 'CONFIRM' ||
                      status == 'CANCEL' ||
                      (status == 'PENDING' && selectedPurchasePlanItem.id >= 0)
                  "
                  :rules="rules.currencyRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="unitCost"
                  label="Unit Cost"
                  v-model="selectedPurchasePlanItem.unitCost"
                  type="number"
                  :rules="rules.unitCostRules"
                  @input="
                    selectedPurchasePlanItem.totalCost = parseFloat(
                      selectedPurchasePlanItem.planQty *
                        selectedPurchasePlanItem.unitCost
                    ).toFixed(6)
                  "
                  :readonly="
                    status == 'CONFIRM' ||
                      status == 'CANCEL' ||
                      (status == 'PENDING' && selectedPurchasePlanItem.id >= 0)
                  "
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="Plan Qty"
                  label="Plan Qty"
                  v-model="selectedPurchasePlanItem.planQty"
                  type="number"
                  :rules="rules.qtyRules"
                  @input="
                    selectedPurchasePlanItem.totalCost = parseFloat(
                      selectedPurchasePlanItem.planQty *
                        selectedPurchasePlanItem.unitCost
                    ).toFixed(6)
                  "
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="TotalCost"
                  label="Total Cost"
                  v-model="selectedPurchasePlanItem.totalCost"
                  type="number"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="PO Qty"
                  label="PO Qty"
                  v-model="selectedPurchasePlanItem.poQty"
                  type="number"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="Description"
                  label="Description"
                  v-model="selectedPurchasePlanItem.description"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="selectedPurchasePlanItem.remark"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="closePurchasePlanItemDialog">
                    Close
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      !detailValid || status == 'CONFIRM' || status == 'CANCEL'
                    "
                    @click="addPurchasePlanItem"
                  >
                    Add
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="purchasePlanAssetDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title class="blue darken-3">
          <span class="title white--text">Purchase Plan Asset</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="assetForm" v-model="assetValid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="Asset Name"
                  label="Asset Name"
                  v-model="selectedPurchasePlanAsset.assetName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="Unit Name"
                  label="Unit Name"
                  v-model="selectedPurchasePlanAsset.unitName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-autocomplete
                  v-model="selectedPurchasePlanAsset.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                  :readonly="
                    status == 'CONFIRM' ||
                      status == 'CANCEL' ||
                      (status == 'PENDING' && selectedPurchasePlanAsset.id >= 0)
                  "
                  :rules="rules.currencyRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="unitCost"
                  label="Unit Cost"
                  v-model="selectedPurchasePlanAsset.unitCost"
                  type="number"
                  :rules="rules.unitCostRules"
                  @input="
                    selectedPurchasePlanAsset.totalCost = parseFloat(
                      selectedPurchasePlanAsset.planQty *
                        selectedPurchasePlanAsset.unitCost
                    ).toFixed(6)
                  "
                  :readonly="
                    status == 'CONFIRM' ||
                      status == 'CANCEL' ||
                      (status == 'PENDING' && selectedPurchasePlanAsset.id >= 0)
                  "
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="Plan Qty"
                  label="Plan Qty"
                  v-model="selectedPurchasePlanAsset.planQty"
                  type="number"
                  :rules="rules.qtyRules"
                  @input="
                    selectedPurchasePlanAsset.totalCost = parseFloat(
                      selectedPurchasePlanAsset.planQty *
                        selectedPurchasePlanAsset.unitCost
                    ).toFixed(6)
                  "
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="TotalCost"
                  label="Total Cost"
                  v-model="selectedPurchasePlanAsset.totalCost"
                  type="number"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="PO Qty"
                  label="PO Qty"
                  v-model="selectedPurchasePlanAsset.poQty"
                  type="number"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="Description"
                  label="Description"
                  type="text"
                  v-model="selectedPurchasePlanAsset.description"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                  :rules="rules.lengthRules(500, 'Description')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="remark"
                  label="Remark"
                  type="text"
                  v-model="selectedPurchasePlanAsset.remark"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                  :rules="rules.lengthRules(500, 'Remark')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="purchasePlanAssetDialog = !purchasePlanAssetDialog"
                  >
                    Close
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      !assetValid || status == 'CONFIRM' || status == 'CANCEL'
                    "
                    @click="addPurchasePlanAsset"
                  >
                    Add
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Product Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand Name"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category Name"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group Name"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="headers"
              :items="productList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td
                  @click="
                    setProduct(props.item.code),
                      (showProductListDialog = !showProductListDialog)
                  "
                >
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.brand.name }}</td>
                <td>{{ props.item.category.name }}</td>
                <td v-if="props.item.productGroup">
                  {{ props.item.productGroup.name }}
                </td>
                <td v-else></td>
                <td>{{ props.item.description }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Asset List Dialog -->
    <v-dialog v-model="showAssetListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Asset name"
                type="text"
                class="mr-1"
                v-model="queryParamsAssets.assetName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="type"
                label="Asset Type"
                type="text"
                class="mr-1"
                v-model="queryParamsAssets.assetType"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchAsset">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Asset List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="assetPopupHeaders"
              :items="depreciationList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :paginationAsset.sync="paginationAsset"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td
                  @click="
                    setAsset(props.item.assetName),
                      (showAssetListDialog = !showAssetListDialog)
                  "
                >
                  <a>{{ props.item.assetName }}</a>
                </td>
                <td>{{ props.item.assetType }}</td>
                <td>{{ props.item.cost }}</td>
                <td>{{ props.item.description }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- error message dialog -->
    <v-dialog
      v-model="errorMessageBox"
      max-width="500px"
      @keydown.enter="closeErrMsgBox"
      @keydown.esc="closeErrMsgBox"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeErrMsgBox"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import { procurementPlanService } from "../../services/procurement-plan-service";
import { supplierService } from "../../services/supplier-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import {
  ProcurementPlan,
  PurchasePlanItem,
  PurchasePlanAsset,
} from "../../models/model";
import { ProcurementPlanFormRules } from "../../helpers/validation-rules";
import { productService } from "../../services/product-service";
import { currencyService } from "../../services/currency-service";
import { assetService } from "../../services/asset-service";

export default {
  name: "ProcurementPlanDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    detailValid: true,
    assetValid: true,
    breadcrumbs: [
      {
        text: "Procurement Plan",
        disabled: false,
        to: "procurement-plans",
      },
      {
        text: "Procurement Plan Detail",
        disabled: true,
      },
    ],
    issueDate: "",
    estArrivalDate: "",
    procurementPlan: new ProcurementPlan(),
    oldprocurementPlan: new ProcurementPlan(),
    purchasePlanItem: new PurchasePlanItem(),
    selectedPurchasePlanItem: new PurchasePlanItem(),
    purchasePlanAsset: new PurchasePlanAsset(),
    selectedPurchasePlanAsset: new PurchasePlanAsset(),
    rules: new ProcurementPlanFormRules(),
    responseError: "",
    showAutocompleteLoading: false,
    purchasePlanItemDialog: false,
    purchasePlanAssetDialog: false,
    saveLoading: false,
    activeWarehouseList: [],
    tempList: [],
    productUnitList: [],
    depreciationList: [],
    currencyList: [],
    defaultCurrencyId: "",
    productList: [],
    supplierList: [],
    supplierListLoading: false,
    btnDisabled: false,
    isItemDiscount: false,
    typeList: [],
    status: "DRAFT",
    showProductListDialog: false,
    showAssetListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    paginationAsset: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "assetName",
      totalItems: 0,
    },
    totalRows: 0,
    updatedDate: "",
    createdDate: "",
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      isPurchase: true,
    },
    queryParamsAssets: {
      assetName: "",
      assetType: "",
      statusList: ["DRAFT", "CONFIRM"],
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedId: 0,
    totalPOAmount: 0,
    files: [],
    scanBarcode: "",
    barcodeLoading: false,
    errorMessageBox: false,
    totalPOMMKAmount: 0,

    detailHeaders: [
      { text: "Code", sortable: false },
      { text: "Product", sortable: false },
      { text: "Currency", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Plan Qty", align: "center", sortable: false },
      { text: "PO Qty", align: "center", sortable: false },
      { text: "Unit Cost", align: "center", sortable: false },
      { text: "Total Cost", align: "center", sortable: false },
      { text: "Description", sortable: false },
      { text: "Remark", sortable: false },
      { text: "Action", sortable: false },
    ],
    assetHeaders: [
      { text: "Asset Name", sortable: false },
      { text: "Currency", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Plan Qty", align: "center", sortable: false },
      { text: "Unit Cost", align: "center", sortable: false },
      { text: "Total Cost", align: "center", sortable: false },
      { text: "Description", sortable: false },
      { text: "Remark", sortable: false },
      { text: "Action", sortable: false },
    ],
    assetPopupHeaders: [
      { text: "Asset Name", value: "assetName", sortable: false },
      { text: "Asset Type", value: "assetType", sortable: false },
      { text: "Cost", value: "cost", sortable: false },
      { text: "Description", value: "description", sortable: false },
    ],
    detailCodeSearch: "",
    detailNameSearch: "",
    assetNameSearch: "",
    supplierProductError: "",
  }),

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
    paginationAsset: {
      handler() {
        this.getAssetList();
      },
      deep: true,
    },
  },

  computed: {
    detailList() {
      return this.procurementPlan.purchasePlanItemList.filter((d) => {
        if (this.detailCodeSearch && this.detailNameSearch)
          return (
            d.productCode
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1 &&
            d.productName
              .toLowerCase()
              .indexOf(this.detailNameSearch.toLowerCase()) > -1
          );
        else if (this.detailCodeSearch)
          return (
            d.productCode
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1
          );
        else if (this.detailNameSearch)
          return (
            d.productName
              .toLowerCase()
              .indexOf(this.detailNameSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
    assetDetailList() {
      return this.procurementPlan.procurementPlanAssetList.filter((d) => {
        if (this.assetNameSearch)
          return (
            d.assetName
              .toLowerCase()
              .indexOf(this.assetNameSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
    statusList() {
      if (this.status == "DRAFT") {
        return [
          { label: "DRAFT", value: "DRAFT" },
          { label: "PENDING", value: "PENDING" },
          { label: "CONFIRM", value: "CONFIRM" },
          { label: "CANCEL", value: "CANCEL" },
        ];
      } else if (this.status == "PENDING") {
        return [
          { label: "PENDING", value: "PENDING" },
          { label: "CONFIRM", value: "CONFIRM" },
        ];
      } else {
        return [
          { label: "CONFIRM", value: "CONFIRM" },
          { label: "CANCEL", value: "CANCEL" },
        ];
      }
    },
  },

  created() {
    this.getActiveWarehouseList();
    this.getCurrencies();
    this.getAlltypes();
    const id = this.$route.params.id;
    this.toggleDiscount();
    if (id == "new") {
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      if (
        this.user.roleName == "WAREHOUSE_MANAGER" ||
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "WAREHOUSE_STAFF" ||
        this.user.role.roleName == "PROCUREMENT_MANAGER"
      ) {
        this.procurementPlan.warehouseId = this.user.warehouseId;
        this.queryParams.warehouseId = this.user.warehouseId;
      }
      if (
        this.user.roleName == "SALE_MANAGER" ||
        this.user.roleName == "GENERAL_MANAGER"
      ) {
        this.procurementPlan.warehouseId = this.user.shop.warehouseId;
        this.queryParams.warehouseId = this.user.shop.warehouseId;
      }
    } else {
      this.getProcurementPlanDetail(id);
      this.getProductList();
    }
  },

  methods: {
    getCurrencies() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
          let currency = commonService.search(
            "defaultCurrency",
            true,
            this.currencyList
          );
          if (currency) this.defaultCurrencyId = currency.id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAlltypes() {
      procurementPlanService
        .getAllProcurementPlanTypes("RAW")
        .then((res) => {
          let tempList = res.data;
          tempList.forEach((temp) => {
            let tempObj = { label: temp, value: temp };
            this.typeList.push(tempObj);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    onSearchAsset() {
      this.queryParamsAssets.page = this.paginationAsset.page;
      this.queryParamsAssets.size = this.paginationAsset.rowsPerPage;
      this.getAssetList();
    },

    getWarehouseList() {
      var temp;
      var tempWarehouseList = [];
      temp = this.procurementPlan.warehouse.name;
      if (!this.tempList.includes(temp)) {
        this.tempList.push(temp);
        tempWarehouseList.push(this.procurementPlan.warehouse);
      }

      for (var j = 0; j < this.activeWarehouseList.length; j++) {
        temp = this.activeWarehouseList[j].name;
        if (!this.tempList.includes(temp)) {
          this.tempList.push(temp);
          tempWarehouseList.push(this.activeWarehouseList[j]);
        }
      }
      this.activeWarehouseList = tempWarehouseList;
    },

    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail = this.procurementPlan.purchasePlanItemList.find(
          (d) => d.id == id
        );
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id * -1;
    },
    generateAssetId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail = this.procurementPlan.procurementPlanAssetList.find(
          (d) => d.id == id
        );
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id * -1;
    },
    addPurchasePlanItem() {
      if (this.$refs.detailForm.validate()) {
        // deep copy
        let poItem = JSON.parse(JSON.stringify(this.selectedPurchasePlanItem));

        let currency = this.currencyList.find((c) => c.id == poItem.currencyId);
        if (currency) poItem.currencyCode = currency.code;
        const index = this.procurementPlan.purchasePlanItemList
          .map((d) => d.id)
          .indexOf(poItem.id);
        if (index > -1) {
          this.procurementPlan.purchasePlanItemList.splice(index, 1, poItem);
        } else {
          this.procurementPlan.purchasePlanItemList.unshift(poItem);
        }
        this.closePurchasePlanItemDialog();
      }
    },

    closePurchasePlanItemDialog() {
      this.purchasePlanItemDialog = !this.purchasePlanItemDialog;
    },

    editDetail(poItem) {
      this.selectedPurchasePlanItem = JSON.parse(JSON.stringify(poItem));
      this.purchasePlanItemDialog = true;
    },

    removePurchasePlanItem(purchasePlanItemId) {
      const index = this.procurementPlan.purchasePlanItemList
        .map((d) => d.id)
        .indexOf(purchasePlanItemId);

      if (!this.procurementPlan.purchasePlanItemList[index].isNew) {
        // add delete purchasePlanItem id
        if (!this.procurementPlan.deletePurchasePlanItemIds) {
          this.procurementPlan.deletePurchasePlanItemIds = [];
        }
        this.procurementPlan.deletePurchasePlanItemIds.push(purchasePlanItemId);
      }
      this.$delete(this.procurementPlan.purchasePlanItemList, index);
    },

    addPurchasePlanAsset() {
      if (this.$refs.assetForm.validate()) {
        // deep copy
        let poItem = JSON.parse(JSON.stringify(this.selectedPurchasePlanAsset));

        let currency = this.currencyList.find((c) => c.id == poItem.currencyId);
        if (currency) poItem.currencyCode = currency.code;
        const index = this.procurementPlan.procurementPlanAssetList
          .map((d) => d.id)
          .indexOf(poItem.id);
        if (index > -1) {
          this.procurementPlan.procurementPlanAssetList.splice(
            index,
            1,
            poItem
          );
        } else {
          this.procurementPlan.procurementPlanAssetList.unshift(poItem);
        }
        this.purchasePlanAssetDialog = !this.purchasePlanAssetDialog;
      }
    },

    editAsset(poItem) {
      this.selectedPurchasePlanAsset = JSON.parse(JSON.stringify(poItem));
      this.purchasePlanAssetDialog = true;
    },

    removePurchasePlanAsset(purchasePlanAssetId) {
      const index = this.procurementPlan.procurementPlanAssetList
        .map((d) => d.id)
        .indexOf(purchasePlanAssetId);

      if (!this.procurementPlan.procurementPlanAssetList[index].isNew) {
        // add delete purchasePlanAsset id
        if (!this.procurementPlan.deletePurchasePlanAssetIds) {
          this.procurementPlan.deletePurchasePlanAssetIds = [];
        }
        this.procurementPlan.deletePurchasePlanAssetIds.push(
          purchasePlanAssetId
        );
      }
      this.$delete(this.procurementPlan.procurementPlanAssetList, index);
    },

    getProcurementPlanDetail(id) {
      procurementPlanService
        .getProcurementPlanDetail(id)
        .then((res) => {
          this.procurementPlan = res.data;
          this.isItemDiscount = this.procurementPlan.isItemDiscount;
          this.procurementPlan.warehouse = this.procurementPlan.warehouseDTO;

          this.status = this.procurementPlan.status;

          this.issueDate = commonService.millisecondToDate(
            this.procurementPlan.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );

          if (this.procurementPlan.estArrivalDateInMilliSeconds != null) {
            this.estArrivalDate = commonService.millisecondToDate(
              this.procurementPlan.estArrivalDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          console.log(this.estArrivalDate);
          this.createdDate = commonService.formatDate(
            new Date(this.procurementPlan.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.procurementPlan.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldprocurementPlan = JSON.parse(JSON.stringify(res.data));
          this.getWarehouseList();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getAssetList() {
      this.showListLoading = true;
      let order = this.paginationAsset.descending ? "desc" : "asc";
      return assetService
        .getAssetList(
          this.queryParamsAssets,
          this.paginationAsset.page,
          this.paginationAsset.rowsPerPage,
          this.paginationAsset.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.depreciationList = res.data.assetList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          //convert to millisecond
          this.procurementPlan.issueDateInMilliSeconds = commonService.convertToMilliseconds(
            this.issueDate
          );
          // deep copy and remove unecessary objects
          let procurementPlan = JSON.parse(
            JSON.stringify(this.procurementPlan)
          );
          procurementPlan.warehouse = null;
          procurementPlan.warehouseDTO = null;
          procurementPlan.purchasePlanItemList.forEach((detail) => {
            detail.productUnits = null;
            detail.product = null;
            if (detail.isNew) detail.id = null;
          });

          procurementPlan.procurementPlanAssetList.forEach((detail) => {
            if (detail.isNew) detail.id = null;
          });
          procurementPlan.procurementPlanType = "RAW";
          procurementPlanService
            .saveProcurementPlan(procurementPlan)
            .then((res) => {
              if (res) {
                this.goBack();
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },

    initPrice(factorUnitName) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.selectedPurchasePlanItem.productUnits
      );

      this.selectedPurchasePlanItem.productUnitId = productUnit.id;
      this.selectedPurchasePlanItem.actualUnitCost = productUnit.unitCost.toFixed(
        6
      );
      this.selectedPurchasePlanItem.factor = productUnit.factor;
      this.selectedPurchasePlanItem.sellingPrice = productUnit.sellingPrice.toFixed(
        6
      );
      this.selectedPurchasePlanItem.discountPercent =
        productUnit.unitCostPercentage;
    },
    calculateDueDate(periodDays) {
      let dueDateInMilliSeconds = "";
      console.log(">>>>>", periodDays);
      if (periodDays > 0) {
        periodDays = periodDays - 1;
      }
      if (this.issueDate) {
        dueDateInMilliSeconds =
          Number(commonService.convertToMilliseconds(this.issueDate)) +
          periodDays * 24 * 60 * 60 * 1000;
      }
      console.log(">>>milliSec>>", dueDateInMilliSeconds);
      return dueDateInMilliSeconds;
    },
    calculateAllDueDate() {
      this.procurementPlan.purchasePlanItemList.forEach(
        (v) => (v.dueDateInMilliSeconds = this.calculateDueDate(v.periodDays))
      );
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.procurementPlan.id) {
        this.procurementPlan = new ProcurementPlan();
        this.procurementPlan.warehouseId = this.user.warehouseId;
      } else {
        this.procurementPlan = Object.assign({}, this.oldprocurementPlan);
        this.procurementPlan.warehouseId = this.oldprocurementPlan.warehouseId;
        this.isItemDiscount = this.procurementPlan.isItemDiscount;
      }
    },

    getProductList() {
      var this_ = this;
      this_.showListLoading = true;
      this_.productList = [];
      let order = this_.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this_.queryParams,
          this_.pagination.page,
          this_.pagination.rowsPerPage,
          this_.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this_.productList = res.data.productList;
            this_.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this_.showListLoading = false;
        });
    },

    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    showAssets() {
      // Clean query params
      this.queryParamsAssets.assetName = "";
      this.queryParamsAssets.assetType = "";
      this.depreciationList = [];
      this.getAssetList().then(
        (this.showAssetListDialog = !this.showAssetListDialog)
      );
    },
    toggleDiscount() {
      if (this.isItemDiscount) {
        this.procurementPlan.purchasePlanItemList.forEach((element) => {
          let discount = element.unitCost * (element.discountPercent / 100);
          discount = parseFloat(discount).toFixed(6);
          element.unitCost = parseFloat(element.unitCost - discount).toFixed(6);
        });
        this.procurementPlan.isItemDiscount = true;
      } else {
        this.procurementPlan.purchasePlanItemList.forEach((element) => {
          element.unitCost = element.actualUnitCost;
        });
        this.procurementPlan.isItemDiscount = false;
      }
      this.procurementPlan.purchasePlanItemList.forEach((element) => {
        element.sellingPrice = element.sellingPrice;
      });
    },
    setProduct(code) {
      let product = commonService.search("code", code, this.productList);

      this.selectedPurchasePlanItem = new PurchasePlanItem();

      // if no id, add temporary id for key
      if (!this.selectedPurchasePlanItem.id) {
        this.selectedPurchasePlanItem.isNew = true;
        this.selectedPurchasePlanItem.id = this.generateId();
      }
      this.selectedPurchasePlanItem.productId = product.id;
      this.selectedPurchasePlanItem.productCode = product.code;
      this.selectedPurchasePlanItem.productName = product.name;

      // set default unit
      var j = 0;
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.selectedPurchasePlanItem.productUnitId = product.productUnits[j].id;
      this.selectedPurchasePlanItem.factorUnitName =
        product.productUnits[j].factorUnitName;
      this.selectedPurchasePlanItem.factor = product.productUnits[j].factor;
      this.selectedPurchasePlanItem.productUnits = product.productUnits;
      // this.selectedPurchasePlanItem.qty = product.productUnits[j].qty;
      this.selectedPurchasePlanItem.unitCost = product.productUnits[j].unitCost;
      this.selectedPurchasePlanItem.totalCost =
        this.selectedPurchasePlanItem.unitCost *
        this.selectedPurchasePlanItem.planQty;
      this.selectedPurchasePlanItem.currencyId = this.defaultCurrencyId;
      this.purchasePlanItemDialog = !this.purchasePlanItemDialog;
    },
    setAsset(assetName) {
      let asset = commonService.search(
        "assetName",
        assetName,
        this.depreciationList
      );

      this.selectedPurchasePlanAsset = new PurchasePlanAsset();

      // if no id, add temporary id for key
      if (!this.selectedPurchasePlanAsset.id) {
        this.selectedPurchasePlanAsset.isNew = true;
        this.selectedPurchasePlanAsset.id = this.generateAssetId();
      }

      this.selectedPurchasePlanAsset.assetId = asset.id;
      this.selectedPurchasePlanAsset.assetName = asset.assetName;
      this.selectedPurchasePlanAsset.unitId = asset.unitId;
      this.selectedPurchasePlanAsset.unitName = asset.unitName;
      this.selectedPurchasePlanAsset.unitCost = asset.purchaseAmount;
      this.selectedPurchasePlanAsset.planQty = 0;
      this.selectedPurchasePlanAsset.totalCost =
        this.selectedPurchasePlanAsset.unitCost *
        this.selectedPurchasePlanAsset.planQty;
      this.selectedPurchasePlanAsset.currencyId = this.defaultCurrencyId;
      this.purchasePlanAssetDialog = !this.purchasePlanAssetDialog;
    },

    getAllSupplier() {
      supplierService
        .getAllSupplier()
        .then((res) => {
          this.supplierList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onChangeFileUpload(e) {
      this.responseError = "";
      var size = 0;
      this.files = e.target.files;
      if (this.files) {
        for (var i = 0; i < this.files.length; i++) {
          size += this.files[i].size / 1024 / 1024;
        }
      }
      if (size > 30) {
        this.responseError =
          "Upload file size exceeds the maximun upload size!";
      }
    },

    trigger(barcode) {
      if (barcode) {
        this.barcodeLoading = true;
        let params = {
          barcode: barcode,
          isPurchase: true,
        };
        productService
          .getProductUnitByBarcode(params)
          .then((res) => {
            let productUnit = res.data;
            if (productUnit) {
              this.selectedPurchasePlanItem = new PurchasePlanItem();

              // add temporary id for key
              this.selectedPurchasePlanItem.isNew = true;
              this.selectedPurchasePlanItem.id = this.generateId();

              let product = productUnit.product;
              this.selectedPurchasePlanItem.productId = product.id;
              this.selectedPurchasePlanItem.productCode = product.code;
              this.selectedPurchasePlanItem.productName = product.name;
              this.selectedPurchasePlanItem.productUnitId = productUnit.id;
              this.selectedPurchasePlanItem.productUnits[0] = productUnit;
              this.selectedPurchasePlanItem.factorUnitName =
                productUnit.factorUnitName;
              this.selectedPurchasePlanItem.factor = productUnit.factor;

              this.selectedPurchasePlanItem.unitCost = productUnit.unitCost;
              this.selectedPurchasePlanItem.totalCost =
                productUnit.unitCost * this.selectedPurchasePlanItem.planQty;
              this.selectedPurchasePlanItem.currencyId = this.defaultCurrencyId;
              this.purchasePlanItemDialog = true;
            }
          })
          .catch((err) => {
            console.error(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.errorMessageBox = true;
            }
          })
          .finally(() => {
            this.scanBarcode = "";
            this.barcodeLoading = false;
          });
      }
    },

    closeErrMsgBox() {
      this.errorMessageBox = false;
      this.responseError = "";
    },
  },
};
</script>
